import { cva } from 'class-variance-authority';

export const paginationDotsVariants = 'flex items-center gap-2';

export const dotClasses = cva(
  [
    'h-2-5 w-2-5 rounded-full transition-all duration-300 ease-in-out',
    'focus:ring-charcoal-300 focus:ring-2 focus:ring-offset-2 focus:outline-none'
  ],
  {
    variants: {
      state: {
        active: 'bg-charcoal-alpha-500 w-5',
        inactive: 'bg-charcoal-alpha-100'
      }
    },
    defaultVariants: {
      state: 'inactive'
    }
  }
);
